import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-patients-plan-pricing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './patients-plan-pricing.component.html',
  styleUrl: './patients-plan-pricing.component.scss'
})
export class PatientsPlanPricingComponent {

}
